<template>
  <div>
    <v-radio-group v-model="value.selectedValue" @change="radioChanged" v-if="value">
      <template v-for="(item, index) in value.values">
        <v-radio :value="item.id" :key="index">
          <template v-slot:label>
            <div>{{ item.label }}</div>
            <div v-if="relatedValue == item.id" class="ml-4" style="border: 1px dashed green"> - Valgt ved innflytting</div>
          </template>
        </v-radio>
      </template>
    </v-radio-group>
  </div>
</template>


<script>
export default {
  props: ["value", "relatedVmodel"],
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(function () {
      if(this.relatedVmodel) {
        for(let item in this.value.values) {
          if(this.value.values[item].id == this.relatedVmodel.selectedValue && !this.value.loadedFromRelated) {
            this.value.selectedValue = this.relatedVmodel.selectedValue
            this.value.loadedFromRelated = true
          }
        }
      }
    })
    
  },
  methods: {
    radioChanged: function(event) {
      this.$emit("update-fields");
    }
  },
  computed: {
    dark: {
      get() {
        if (this.$store.state.fields.dark) {
          return this.$store.state.fields.dark;
        }
        return false;
      }
    },
    relatedValue: function() {
      if(this.relatedVmodel) {
        return this.relatedVmodel.selectedValue
      }
      return null
    }
  }
};
</script>
